import React from 'react';

function SingleLine({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <path d="M9 4C11 4 12 5.5 12 7M12 7C12 8.5 12 14 12 17M12 7C12 4.6 14 4 15 4M12 17C12 19.4 10 20 9 20M12 17C12 19.4 14 20 15 20" />
      <path d="M10.5 12H13.5" />
    </svg>
  );
}

export default SingleLine;
